import React from 'react';
import '../styles/DarkModeToggle.css'; // تأكد من استيراد ملف الـ CSS المحدث

const DarkModeToggle = ({ isDarkMode, toggleDarkMode }) => {
  return (
    <button
      className={`dark-mode-toggle ${isDarkMode ? 'dark-active' : ''}`}
      onClick={toggleDarkMode}
      type="button"
      role="switch"
      aria-checked={isDarkMode}
      aria-label="Toggle Dark Mode"
    >
      <div className="toggle-track">
        {/* الدائرة المتحركة - عنصر منفصل */}
        <div className="toggle-thumb" />

        {/* أيقونة الشمس - عنصر منفصل */}
        <div className="icons-container sun-container">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="icon sun-icon">
            <circle cx="12" cy="12" r="5" />
            <path d="M12 2V4M12 20V22M4.93 4.93L6.34 6.34M17.66 17.66L19.07 19.07M2 12H4M20 12H22M4.93 19.07L6.34 17.66M17.66 6.34L19.07 4.93" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>

        {/* أيقونة القمر - عنصر منفصل (تم التعديل هنا) */}
        <div className="icons-container moon-container">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="icon moon-icon">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
          </svg>
        </div>
      </div>
    </button>
  );
};

export default DarkModeToggle;